import * as React from "react";
import {Container,Row, Col, CardImg, Card} from "reactstrap";
import Footer from "./Footer";
import "./ContactUs.css";

const contactus = require('../images/contact-us.png');

/**
 * 
 * 
 * @export
 * @class App
 * @extends {React.Component<{}, {}>}
 */
export default class ContactUs extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);       
    }  
    render() {
        return (       
            <Container id="contactUs" className = "header-container2" style= {{paddingTop:50}}> 
                <Row>Contact Us</Row>
                <Row>
                    <Col sm="4" > 
                        <Container  >                            
                            <Row>No. 14A, St. Joseph School Road,</Row>
                            <Row>Poonmallee,</Row>
                            <Row>Chennai - 56</Row>            
                            <Row>Mobile:</Row>
                            <Row>+91 93846 45616</Row>
                            <Row>+91 96001 51409</Row>
                        </Container> 
                    </Col>
                    <Col sm="8" >             
                        <Container style= {{paddingLeft:50}}>
                            <Card>
                                <CardImg top width="100%" src={contactus} alt="Card image cap" />        
                            </Card>
                        </Container> 
                    </Col> 
                </Row>                       
            </Container>
        );
    }
}






// WEBPACK FOOTER //
// ./src/components/views/ContactUs.tsx